import { useState } from 'react'
import { ITag } from '@/interfaces/ITag'
import { IFeedRecord } from '@/interfaces/IFeedRecord'
import NextLink from 'next/link'
import Chip from '@mui/material/Chip'
import styles from './ChipBar.module.scss'
import TopicIcon from '@mui/icons-material/Topic'
// import AdsClickIcon from '@mui/icons-material/AdsClick'
import BarChartIcon from '@mui/icons-material/BarChart'
import numeral from 'numeral'
import { useTranslations } from 'next-intl'

interface ChipBarProps {
  record: IFeedRecord
  selectedTag?: ITag | null
}

function formatLikes (viewCount: number): string {
    // Check if the number is close to a million (e.g., 950,000 to 999,999)
    if (viewCount >= 950000 && viewCount < 1000000) {
      // Use a more precise format for this range
      return numeral(viewCount).format('0,0.0').replace('.0', '') + 'k'
    } else {
      // Use the default formatting for other numbers
      return numeral(viewCount).format('0.0a').replace('.0', '')
    }
  }

function ChipEle ({ id, name, marginRight }: { id?: string, name?: string, marginRight?: string }) {
  return (
    <NextLink href={`/feed?topic=${id || ''}`} style={{ marginRight }}>
      <Chip
        label={name}
        className={styles.tagChip}
        size='medium'
        avatar={<TopicIcon />}
        variant={'outlined'}
        style={{
          marginBottom: '0.5rem'
        }}
      />
    </NextLink>
  )
}

function ChipBar ({ record }: ChipBarProps) {
  const [expanded, setExpanded] = useState(false)

  const selectedTag = record.tags[0]

  const t = useTranslations('FeedSidebar')

  return (
    <div className={styles.feedRowBottom}>
      <div className={styles.tagBar}>
        <div className={styles.feedRowBottomLeft}>
          <div>
            <Chip
              label={`${formatLikes(record.viewCount)}`}
              size='medium'
              avatar={<BarChartIcon />}
              variant={'outlined'}
              className={styles.tagChip}
              style={{
                marginBottom: '0.5rem',
                marginRight: '0.5rem'
              }}
            />
          </div>
          {selectedTag &&
            <ChipEle
              id={selectedTag.id}
              name={selectedTag.name}
              marginRight={expanded ? '0.5rem' : '0px'}
            />
          }
          {!selectedTag && record.tag &&
            <ChipEle
              id={record.tag?.id}
              name={record.tag?.name}
              marginRight={expanded ? '0.5rem' : '0px'}
            />
          }
          {record.tags.length > 1 &&
            <>
              {!expanded &&
                <div
                  style={{
                    // display vertically center
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginLeft: '0.25rem',
                    paddingBottom: '0.4rem'
                  }}
                >
                  <span
                    onClick={() => setExpanded(true)}
                    style={{
                      marginLeft: '0.25rem',
                      cursor: 'pointer',
                      fontSize: '0.75rem',
                      color: 'var(--secondary-font-rgb)'
                    }}
                  >
                    {t('show-more')}
                  </span>
                </div>
              }
              {expanded &&
                <>
                  {record.tags.filter(obj => obj.id !== selectedTag.id).map((tag) => (
                    <ChipEle
                      key={tag.id}
                      id={tag.id}
                      name={tag.name}
                      marginRight={expanded ? '0.5rem' : '0px'}
                    />
                  ))}
                </>
              }
            </>
          }
        </div>
      </div>
    </div>
  )
}

export default ChipBar
